module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "header": 'What kind of Roundtable?',
      "headerStyle": 'font-weight: bold; font-size: 24px;',
      "maxWidth": '900px',
      "maxHeight": '610px',
      "height": '453px',
      "padding": '2em'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('section', {
    key: "live-online",
    staticClass: "choose-universe-live-online h-auto flex flex-wrap"
  }, [_c('div', {
    staticClass: "flex-grow tc pt4"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": function($event) {
        return _vm.createPremade('online')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px"
    },
    attrs: {
      "src": "/static/online_roundtable_icons/online.svg",
      "alt": "written roundtable"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("Written")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n          A tool for written blended discussions and collaboration.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pill-online pl-caption"
  }, [_vm._v("Create Written RoundTable")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow tc pt4"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": function($event) {
        return _vm.createPremade('live')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px"
    },
    attrs: {
      "src": "/static/live_discussion/live.svg",
      "alt": "verbal discussion"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("Verbal")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n          A tool for facilitating and tracking face-to-face discussions.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pill-live pl-caption"
  }, [_vm._v("Create Verbal RoundTable")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-45d830fd!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/createPremadeModal.vue
// module id = 1398
// module chunks = 61